export class ToggleScroll {
  static enable() {
    document.body.style.paddingRight = '';
    document.body.classList.remove('prevent-scroll');
    document.body.removeAttribute('data-position');
  }

  static disable() {
    const scrollbarWidth = getComputedStyle(document.documentElement).getPropertyValue('--scrollbar-width') || '4px';

    // Сохраняем текущую позицию скролла
    document.body.dataset.position = window.scrollY;
    document.body.style.paddingRight = scrollbarWidth;
    document.body.classList.add('prevent-scroll');
  }
}
